<script setup lang="ts">
	withDefaults(defineProps<{ text?: string; active: boolean }>(), {
		text: 'loading...'
	})
</script>

<template>
	<transition
		enter-active-class="animate__animated animate__fadeIn"
		leave-active-class="animate__animated animate__fadeOut"
	>
		<div
			v-if="active"
			class="fixed left-0 top-0 z-[100000] flex h-full w-full cursor-progress flex-col items-center justify-center bg-[rgba(0,0,0,0.5)] text-center backdrop-blur-sm"
			data-testid="loader"
		>
			<div class="pointer-events-none flex flex-col items-center justify-center">
				<div class="cover-cap">
					<lazy-tools-icon icon="mcg-cap" dir="fill" svg-class="cover-cap-svg" />
				</div>

				<div class="mt-4 flex items-baseline text-[24px] font-[700] capitalize leading-[28px] text-white">
					{{ text?.replace(/\./g, '') }}
					<div class="loading relative">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<style lang="postcss">
	.cover-cap {
		transition: 400ms ease-in-out;
		width: 98.77px;
		height: 98.77px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: #fff;
	}

	.cover-cap-svg {
		transition: 2s ease-in-out;
		animation: cap 2s cubic-bezier(0.14, 0.37, 0.93, 1.19) infinite;
		animation-play-state: running;
		transform-origin: center;
		transform-style: preserve-3d;
	}

	@keyframes cap {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.3);
		}
		100% {
			transform: scale(1);
		}
	}

	.loading span {
		animation: blink 1.5s infinite;
		animation-fill-mode: both;
		height: 5px;
		width: 5px;
		background: #e7eeff;
		position: absolute;
		transform: translate(3px, -4px);
		border-radius: 50%;
	}
	.loading span:nth-child(2) {
		animation-delay: 0.2s;
		margin-left: 7px;
	}
	.loading span:nth-child(3) {
		animation-delay: 0.2s;
		margin-left: 14px;
	}

	@keyframes blink {
		0% {
			opacity: 0.1;
		}
		20% {
			opacity: 1;
		}
		100% {
			opacity: 0.1;
		}
	}
</style>
